import React, { useRef, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { RootState } from '&store/store';

import { FaqWrapper } from './faq.styled';
import BackgroundImg from '&assets/images/AWS-Empty-8.jpg';
import Container from '../../components/container/container.component';

type ReduxProps = ConnectedProps<typeof connector>;

const FAQComponent = (props: ReduxProps) => {
	const { t } = useTranslation(['home']);
	const [selectedQuestion, setSelectedQuestion] = useState('');
	const ref = useRef(null);

	const faqs = [
		{
			question: 'What is the AWS Challenge?',
			answer:
				'The AWS Challenge provides students with the opportunity to showcase their innovative ideas for startups within the ecosystem. Participants leverage creative approaches and the power of technology to accelerate advancement.',
		},
		{
			question: 'When will the AWS Challenge start?',
			answer:
				'The AWS Challenge is scheduled to commence on the 5th of May 2024',
		},
		{
			question: 'How can I submit for the challenge?',
			answer:
				'To submit for the AWS Challenge, select “Apply Now” to fill out the form.',
		},
		{
			question:
				'How many students will be selected and what is the maximum number of teams that will be formed for the challenge at GUST?',
			answer:
				'A total of 20 students, organized into 4 teams, will be selected as finalists to partake in the challenge over the span of a week.',
		},
		{
			question: 'What are the prizes for the challenge?',
			answer:
				'Winners of the AWS Challenge will receive significant awards; yet to be confirmed at a later stage.',
		},
	];

	const handleSelected = (question: string, index: number) => {
		setSelectedQuestion(question);
		const selectedElement = document.getElementById(`faq-${index}`);
		if (selectedElement) {
			selectedElement.scrollIntoView({
				behavior: 'smooth',
				block: 'center',
			});
		}
	};

	return (
		<FaqWrapper backgroundImage={BackgroundImg}>
			<div className="challenge-header">
				<p className="challenge-name">FAQ</p>
			</div>
			<Container>
				<div className="content">
					<div className="answers">
						{faqs.map((faq: any, index: number) => {
							return (
								<div id={`faq-${index}`} key={index} className="faq">
									<h2 className="title">{faq.question}</h2>
									<p className="description">{faq.answer}</p>
								</div>
							);
						})}
					</div>
					<div className="questions">
						{faqs.map((faq: any, index: number) => {
							return (
								<div
									key={index}
									className={`faq ${
										faq.question === selectedQuestion ? 'selected' : ''
									}`}
									onClick={() => handleSelected(faq.question, index)}
								>
									<h2 className="title">{faq.question}</h2>
								</div>
							);
						})}
					</div>
				</div>
			</Container>
		</FaqWrapper>
	);
};

const mapStateToProps = (state: RootState) => ({});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
const FAQComponentRedux = connector(FAQComponent);

export { FAQComponentRedux as FAQComponent };
